import axios from 'axios'
import AuthToken from '@/auth/auth-token'
import qs from 'qs'

class Items {
  constructor () {
    const items = axios.create({
      baseURL: process.env.BASE_API,
      withCredentials: false,
      headers: {
        'Content-type': 'application/json'
      }
    })
    this.items = items

    items.interceptors.response.use(this.handleSuccess)
  }

  handleSuccess (response) {
    let data = response.data

    return data
  }

  async searchItems (data = {}, offset = 0, limit = 50, is_retailer = false, search_similar_upc = false) {
    await AuthToken.setAuth(this.items)
    return this.items({
      url: '/search',
      method: 'POST',
      params: { offset, limit, is_retailer, search_similar_upc },
      data
    })
  }

  async export(payload) {
    await AuthToken.setAuth(this.items)
    return this.items({
      url: `/items/export`,
      method: 'POST',
      data: payload
    })
  }

  async getExportTemplates () {
    await AuthToken.setAuth(this.items)
    return this.items({ url: '/export-templates', method: 'GET' })
  }

  async createExportTemplate (payload) {
    await AuthToken.setAuth(this.items)
    return this.items({ url: '/export-templates', method: 'POST', data: payload })
  }

  async updateExportTemplate (templateId, payload) {
    await AuthToken.setAuth(this.items)
    return this.items({ url: `/export-templates/${templateId}`, method: 'PUT', data: payload })
  }

  async deleteExportTemplate (templateId) {
    await AuthToken.setAuth(this.items)
    return this.items({ url: `/export-templates/${templateId}`, method: 'DELETE' })
  }

  async getExportSchedules () {
    await AuthToken.setAuth(this.items)
    return this.items({ url: '/export-schedules', method: 'GET' })
  }

  async createExportSchedule (payload) {
    await AuthToken.setAuth(this.items)
    return this.items({ url: '/export-schedules', method: 'POST', data: payload })
  }

  async updateExportSchedule (scheduleId, payload) {
    await AuthToken.setAuth(this.items)
    return this.items({ url: `/export-schedules/${scheduleId}`, method: 'PUT', data: payload })
  }

  async deleteExportSchedule (scheduleId) {
    await AuthToken.setAuth(this.items)
    return this.items({ url: `/export-schedules/${scheduleId}`, method: 'DELETE' })
  }

  async getItemByUUID (uuid, catalogName) {
    await AuthToken.setAuth(this.items)
    return this.items({ 
      url: `/getItemById/${uuid}`,
      method: "GET",
      params: {
      catalog_name: catalogName
      }
    })
  }

  async saveNewItem (data) {
    await AuthToken.setAuth(this.items)
    return this.items({
      url: '/saveItem',
      method: 'POST',
      data: data
    })
  }

  async deleteItem (itemId) {
    await AuthToken.setAuth(this.items)
    return this.items({
      url: `/v1/${itemId}`,
      method: 'DELETE'
    })
  }

  async verifyUpc (upc) {
    await AuthToken.setAuth(this.items)
    return this.items({
      url: `/verify-upc`,
      method: 'POST',
      data: { upc }
    })
  }

  async updateItem (data) {
    await AuthToken.setAuth(this.items)
    return this.items({
      url: '/saveItem',
      method: 'PUT',
      data
    })
  }

  async getSources () {
    await AuthToken.setAuth(this.items)
    return this.items({
      url: '/sources',
      method: 'GET'
    })
  }
  
  async getPartySourceRelationships () {
    await AuthToken.setAuth(this.items)
    return this.items({
      url: '/sources/relationships',
      method: 'GET'
    })
  }

  async copyItem (item_id, source, source_list) {
    await AuthToken.setAuth(this.items)
    return this.items({
      url: '/copy_item_to_sources/',
      method: 'POST',
      params: { item_id, source },
      data: source_list
    })
  }

  async getPossibleValues (column, downstream_column = null, sources = [], is_retailer = false) {
    const params = { sources, is_retailer, downstream_column }
    await AuthToken.setAuth(this.items)
    return this.items({
      url: `/possible_values/${column}`,
      method: 'GET',
      params: params,
      paramsSerializer: params => {
        return qs.stringify(params, { indices: false, encode: false })
      }
    })
  }

  async getItemDepartments () {
    await AuthToken.setAuth(this.items)
    return this.items({
      url: '/item_departments',
      method: 'GET'
    })
  }

  async getStoreItemRestrictions (storeId) {
    await AuthToken.setAuth(this.items)
    return this.items({
      url: '/store-item-restrictions',
      method: 'GET',
      params: { store_id: storeId }
    })
  }

  async addStoreItemRestrictions (payload) {
    await AuthToken.setAuth(this.items)
    return this.items({
      url: '/store-item-restrictions',
      method: 'POST',
      data: payload
    })
  }

  async removeStoreItemRestrictions (payload) {
    await AuthToken.setAuth(this.items)
    return this.items({
      url: '/store-item-restrictions/remove',
      method: 'POST',
      data: payload
    })
  }
}

export default new Items()



// WEBPACK FOOTER //
// ./src/api/endpoints.js